import styled from "styled-components";
import {JackpotBetWidgetGradientTextDefaultBox} from "./jackpot-bet-widget-gradient-text.default.box";

export const JackpotBetWidgetGradientText777Box = styled(JackpotBetWidgetGradientTextDefaultBox)`

  letter-spacing: 0;
  line-height: 100%;
  
  font-weight: 300;
  
  text-transform: ${props => props.dontUpperCase ? "initial" : "uppercase"};

  background: #671C2D;

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  text-shadow: 0 2px 5px 0 #00000040; 
  
  padding: 1px 0px;
`;
